import React from 'react'
import cx from 'classnames'

import styles from './Progress.module.scss'

/**
 * Show loading / progress status.
 * @param {Object} props
 * @param {string} [props.className]
 */
const Progress = (props) => {
    const {
        className,
    } = props

    const classNames = cx({
        [styles.container]: true,
        [className]: !!className,
    })

    return (
        <div className={classNames}>
            <div className={styles.spinner}/>
        </div>
    )
}

export default Progress
